import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { logError } from "@/lib/logger";
import { HTTP_UNAUTHORIZED } from "@/lib/constants";

const AuthContext = createContext(null);

async function fetchMe() {
    try {
        const { data } = await api.get("/auth/me");
        return data;
    } catch (e) {
        if (e?.response?.status !== HTTP_UNAUTHORIZED) logError("Failed to load /auth/me", e);
        return null;
    }
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const u = await fetchMe();
        setUser(u);
        setLoading(false);
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch (e) { logError("Logout failed", e); }
        setUser(null);
    }, []);

    const value = useMemo(
        () => ({ user, setUser, loading, logout, refresh }),
        [user, loading, logout, refresh],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
